import { useMemo } from "react";

import { TreePicklistItem } from "../../TreePicklistItem";

export const useChildrenNodesNeedToOpen = (elementId: string, nodesNeedToOpen: TreePicklistItem[]) =>
    useMemo(() => nodesNeedToOpen.filter(item => item.parentElementId === elementId), [elementId, nodesNeedToOpen]);
